import { IxList } from './IxList.js';

window.customElements.define('ix-list', IxList);
